import React from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';
import '../styles/featuresComponent.css';

const pillars = [
  {
    icon: 'shield-checkmark-outline',
    title: 'Trust & Reliability',
    description:
      'Transparent processes, accurate reporting, and dependable delivery when decisions carry real weight.',
    image: 'https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=800&q=80',
  },
  {
    icon: 'layers-outline',
    title: 'Integrated Expertise',
    description:
      'Business advisory and technology solutions delivered together under one trusted partner.',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80',
  },
  {
    icon: 'analytics-outline',
    title: 'Strategic Insight',
    description:
      'Practical guidance grounded in financial clarity and operational understanding.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=800&q=80',
  },
  {
    icon: 'people-outline',
    title: 'Long-Term Partnership',
    description:
      'Lasting relationships focused on sustainable growth and resilient operations.',
    image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=800&q=80',
  },
];

function Features() {
  return (
    <section className="features-component" id="features">
      <div className="container">
        <ScrollReveal className="features-header">
          <p className="section-eyebrow">Why QASHQ</p>
          <h2 className="features-heading">Why partner with QASHQ</h2>
          <p className="features-intro">
            Four principles that guide how we work with every client — from first consultation to
            long-term support.
          </p>
        </ScrollReveal>

        <div className="features-tiles">
          {pillars.map((item, index) => (
            <ScrollReveal key={item.title} as="article" className="features-tile" delay={index * 0.06}>
              <Link to="/about" className="features-tile__link" aria-label={`Learn about ${item.title}`}>
                <div className="features-tile__visual">
                  <img src={item.image} alt={item.title} loading="lazy" className="features-tile__img" />
                  <div className="features-tile__overlay" aria-hidden="true"></div>
                  <div className="features-tile__icon" aria-hidden="true">
                    <ion-icon name={item.icon}></ion-icon>
                  </div>
                </div>
                <div className="features-tile__content">
                  <h3 className="features-tile__title">{item.title}</h3>
                  <p className="features-tile__desc">{item.description}</p>
                  <span className="features-tile__cta">
                    Learn more
                    <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                  </span>
                </div>
              </Link>
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal className="features-footer" delay={0.1}>
          <Link to="/about" className="btn btn-outline features-cta">
            Learn About QASHQ
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </Link>
        </ScrollReveal>
      </div>
    </section>
  );
}

export default Features;
